import React, { useEffect } from "react";
import styles from "../videos/videos.module.css";
import { useNavigate } from "react-router-dom";

const Default: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/home");
  });

  return (
    <>
      <div className={`${styles.mainContainer} container mt-5`}>
        <div className={`${styles.rowTitle} row`}>
          <div className={`${styles.colTitle} col-12 mt-4`}>
            <h1 className={`${styles.title}`}>
              Sistema de Entrega Certificada y Trazabilidad Logística
            </h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default Default;
